<template>
  <Index52000
    v-if="templateType === 'Index52000'"
    ref="ModelRef"
    :list="list"
    :type="type"
    :is-has-un-read="isHasUnRead"
    @change="emit('change', $event)"
    @close="emit('close')"
  />
  <Index50000
    v-else-if="templateType === 'Index50000'"
    ref="ModelRef"
    :list="list"
    :type="type"
    :is-has-un-read="isHasUnRead"
    @change="emit('change', $event)"
    @close="emit('close')"
  />
</template>

<script setup>
import { templateTypeWin2FlagWithPopSysNotice } from '@/utils/templateType'
import Index50000 from './template/index_50000.vue'
import Index52000 from './template/index_52000.vue'

defineProps({
  list: {
    type: Array,
    default: () => [],
  },
  type: {
    type: String,
    default: 'atividade',
  },
  isHasUnRead: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['change', 'close'])

const ModelRef = ref(null)

const templateType = computed(() => {
  return templateTypeWin2FlagWithPopSysNotice()
})

defineExpose({
  change: (...args) => ModelRef.value?.change(...args),
  jumpUrl: (...args) => ModelRef.value?.jumpUrl(...args),
})
</script>
